import React from "react";
// import Styles from "./Home.module.css";

const Home = () => {
  const features = [
    {
      title: "Real-Time Board Updates",
      description: "Never miss a notification. We track official exam board activities (SSC, IBPS, TNPSC, etc.) and deliver the latest news directly to you.",
      icon: "🔔",
      badge: "Stay Updated"
    },
    {
      title: "AI Weakness Mapping",
      description: "Our AI analyzes your mock test performance to pinpoint exactly where you’re losing marks—whether it's Quant, Reasoning, or Current Affairs.",
      icon: "🧠",
      badge: "AI Powered"
    },
    {
      title: "Targeted Improvement",
      description: "Stop wasting time on what you already know. Get personalized daily tasks designed to turn your weakest areas into your strongest assets.",
      icon: "📈",
      badge: "Personalized"
    },
    {
      title: "Interactive Community",
      description: "Join a nationwide network of aspirants. Share insights, discuss latest exam patterns, and clear your doubts in our interactive blog.",
      icon: "🤝",
      badge: "Community"
    }
  ];


  return (
    <>
      {/* <div className={Styles.homeContent}>Welcome to My Tutor</div> */}
      <div className="hero bg-base-200">
        <div className="hero-content">
          <div className="max-w-md">
            <h1 className="text-5xl font-bold p-20">AuraTutor</h1>
            <h2 className="text-lg font-bold">Your AI-Powered Path to Govt Service</h2>
            <p className="py-6 text-left">
              Success in competitive exams isn’t just about working hard; it’s about working smart. AuraTutor is the first AI-driven "Self-Tutor" designed specifically for aspirants chasing their dream government career.
              Whether you are preparing for SSC, UPSC, Banking, Railways, or TNPSC, we provide more than just study material—we provide a strategy.
            </p>
            {/* <button className="btn btn-primary">Get Started</button> */}
          </div>
        </div>
        
      </div>

      <div className="py-12 bg-base-200">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Why AuraTutor?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow border border-primary/10">
              <div className="card-body">
                <div className="flex items-center gap-4 mb-2">
                  <div className="text-4xl">{feature.icon}</div>
                  <div className="badge badge-primary badge-outline">{feature.badge}</div>
                </div>
                <h3 className="card-title text-secondary">{feature.title}</h3>
                <p className="text-base-content/80 text-left">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;
